/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-31 11:13:27
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-04 20:44:24
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/ProductSet/tools/validation.ts
 */
import {
  checkCustomInfomation,
  checkActivePrice,
  checkActiveInfo,
  checkDraftInfo,
} from '../../tools/commonDataCheck';
// import {
//   checkSalesChannelAvailableQuantity,
//   checkSalesChannelAvailablePresaleQuantity,
// } from 'src/pages/ProductEditor/tools/commonDataCheck';

import { priceCompare } from './index';
import {
  IAdvancedPriceSettingItem,
  IProductSet,
  IAdvancedPriceSetting,
} from '../type';
import { instanceType, AllTypes } from 'src/tools/helper';

import { EnumStatus } from 'src/types/common/product';
import { scroll } from 'src/tools/helper';
import _ from 'lodash';

export const checkAdvancedPriceSetting = (
  advancedSettings: IAdvancedPriceSetting<IAdvancedPriceSettingItem>[],
) => {
  const adv = _.cloneDeep(advancedSettings || []);
  let flag;
  adv.forEach((i) => {
    const {
      //setPrice,
      items = [],
    } = i;
    // if (!setPrice) {
    //   i.setPriceError = true;
    //   flag = true;
    // }
    // if (!currency) {
    //   i.currencyError = true;
    //   flag = true;
    // }
    items.forEach((item) => {
      if (instanceType(item.unitPrice) !== AllTypes.Number) {
        item.unitPriceError = true;
        i.open = true;
        flag = true;
      }
    });
  });
  return { data: adv, flag };
};

export const checkProductSet = (
  productSet: IProductSet[] = [],
  isDraft: boolean,
) => {
  const set = _.cloneDeep(productSet || []);
  let flag;
  let productSetItemsEmptyError = false;
  if (set.length === 0) {
    if (!isDraft) {
      flag = true;
      productSetItemsEmptyError = true;
    }
  } else {
    set.forEach((i) => {
      const {
        noOfUnit, //unitPrice
      } = i || {};
      if (!noOfUnit) {
        i.noOfUnitError = true;
        flag = true;
      }
      // if (!unitPrice) {
      //   i.unitPriceError = true;
      //   flag = true;
      // }
    });
  }
  return { data: set, flag, empty: productSetItemsEmptyError };
};

// export const checkSalesChannelAvailableQuantity = (
//   isDraft,
//   stockAvailable,
//   salesChannelAvailableQuantity,
// ) => {
//   if (isDraft) {
//     return { flag: false };
//   }
//   const { valid } = checkQuantityAndLeftValid(
//     stockAvailable,
//     salesChannelAvailableQuantity,
//   );
//   return { flag: !valid };
// };

// export const checkSalesChannelAvailablePresaleQuantity = (
//   isDraft,
//   quotaEnabled,
//   inventoryQuota,
//   salesChannelAvailablePresaleQuantity,
// ) => {
//   if (isDraft) {
//     return { flag: false };
//   }
//   if (!quotaEnabled) {
//     return { flag: false };
//   } else {
//     const { valid } = checkQuantityAndLeftValid(
//       inventoryQuota,
//       salesChannelAvailablePresaleQuantity,
//     );
//     return { flag: !valid };
//   }
// };

export const validate = (state, action) => {
  const check = (isDraft) => {
    const {
      productInfo,
      advancedPriceSettings,
      customsInformationItems,
      priceSettings,
      productSetItems,
      // salesChannelAvailableQuantity,
      // salesChannelAvailablePresaleQuantity,
      // stock,
    } = state;
    const { defaultSalePrice } = priceSettings || {};
    // const { quotaEnabled, inventoryQuota, stockAvailable } = stock || {};
    const { flag: infoFlag, data: infoData } = isDraft
      ? checkDraftInfo(productInfo)
      : checkActiveInfo(productInfo) || {};
    if (infoFlag || !infoData) {
      state.productInfo = infoData;
      state.dataValid = false;
      scroll('ProductEditorProductName');
      return;
    }
    // checkAdvancedPriceSetting(advancedPriceSettings);
    if (!isDraft) {
      const priceMismatch = !priceCompare(productSetItems, defaultSalePrice);
      if (priceMismatch) {
        state.dataValid = false;
        scroll('productDefaultPriceSetting');
        return;
      }
    }

    const {
      flag: productSetFlag,
      data: newProductSet,
      empty: productSetIsEmpty,
    } = checkProductSet(productSetItems, isDraft) || {};
    if (productSetFlag || !newProductSet || productSetIsEmpty) {
      state.productSetItems = newProductSet;
      state.productSetItemsEmptyError = productSetIsEmpty;
      state.dataValid = false;
      scroll('ProductEditorProductSetSelection');
      return;
    }

    // const { flag: availableQuantityFlag } = checkSalesChannelAvailableQuantity(
    //   isDraft,
    //   stockAvailable,
    //   salesChannelAvailableQuantity,
    // );
    // if (availableQuantityFlag) {
    //   state.subCollapseOpen.salesChannelAvailableQuantity = true;
    //   state.dataValid = false;

    //   scroll('salesChannelAvailableQuantity');
    //   return;
    // }

    // const calculatePreSale = () => {
    //   const _d = inventoryQuota;
    //   // - stockAvailable;
    //   // if (_d < 0) {
    //   //   return 0;
    //   // }
    //   return _d || 0;
    // };
    // const { flag: availablePresaleQuantityFlag } =
    //   checkSalesChannelAvailablePresaleQuantity(
    //     isDraft,
    //     quotaEnabled,
    //     calculatePreSale(),
    //     salesChannelAvailablePresaleQuantity,
    //   );
    // if (availablePresaleQuantityFlag) {
    //   state.subCollapseOpen.salesChannelAvailablePresaleQuantity = true;
    //   state.dataValid = false;

    //   scroll('salesChannelAvailablePresaleQuantity');
    //   return;
    // }

    const {
      flag: advancedPriceSettingFlag,
      data: latestAdvancedPriceSettings,
    } = checkAdvancedPriceSetting(advancedPriceSettings) || {};
    if (advancedPriceSettingFlag || !latestAdvancedPriceSettings) {
      state.advancedPriceSettings = latestAdvancedPriceSettings;
      state.advancedPriceSettingsOpen = true;
      state.dataValid = false;
      scroll('ProductAdvancedPriceSetting');
      return;
    }
    const { flag: customInfoFlag, data: customInfoData } =
      checkCustomInfomation(customsInformationItems) || {};
    if (customInfoFlag || !customInfoData) {
      state.customsInformationItems = customInfoData;
      state.dataValid = false;
      scroll('ProductCustomInformationSetting');
      return;
    }
    if (!isDraft) {
      const { flag: priceSettingsFlag, data: priceSettingsData } =
        checkActivePrice(priceSettings) || {};
      if (priceSettingsFlag || !priceSettings) {
        state.priceSettings = priceSettingsData;
        state.dataValid = false;
        scroll('productDefaultPriceSetting');
        return;
      }
    }

    state.dataValid = true;
    return;
  };
  const { savedType } = action.payload;
  const type = savedType || state.status;
  if (type === EnumStatus.Draft) {
    check(true);
  }
  if (type === EnumStatus.Active) {
    check(false);
  }
  if (type === EnumStatus.Archived) {
    state.dataValid = true;
  }
};
